import { useEffect, useRef, useState } from 'react';

interface UseDebounceResult<T> {
    debouncedValue: T;
    isWaitingForFirstDebouncedValue: boolean;
}

export function useDebounce<T>(value: T, delayMilliseconds: number = 400): UseDebounceResult<T> {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const [isWaitingForFirstDebouncedValue, setIsWaitingForFirstDebouncedValue] = useState(false);

    const debouncedValueRef = useRef(value);

    useEffect(() => {
        if (!debouncedValueRef.current) {
            setIsWaitingForFirstDebouncedValue(true);
        }

        const handler = setTimeout(() => {
            debouncedValueRef.current = value;
            setDebouncedValue(value);
            setIsWaitingForFirstDebouncedValue(false);
        }, delayMilliseconds);

        return () => clearTimeout(handler);
    }, [value, delayMilliseconds]);

    return {
        debouncedValue,
        isWaitingForFirstDebouncedValue
    };
}
